export default __webpack_public_path__ + "static/media/VisualStudioCode.d662e5e6.png";